const localization = {
    en: {
        headername:"Home",
    },
    ka: {
        headername:"",
    }
}

export default localization;